import React, { useState, useEffect } from "react";
import moment from "moment";
import AccountInfo from "../../../../Profile/AccountInfo"
import { BaseLotInfo } from "../../../../Models/Lots/BaseLotInfoByUser"
import Input from "../../../../FormUi/Input";

interface IPropsType {
    lot: BaseLotInfo,
}

function AboutLotTab(props: IPropsType) {

    const [lot, setLot] = useState(props.lot);
    const [splitedArr, setSplitedArr] = useState([]);
    const [isShowMoreButton, setIsShowMoreButton] = useState(false);
    const [isShowMore, setIsShowMore] = useState(false);

    const showMore = () => {
        if (isShowMore) {
            setLot({ ...lot, Information: splitedArr.slice(0, 40).join(' ') });
            setIsShowMore(false);
        } else {
            setLot({ ...lot, Information: splitedArr.join(' ') });
            setIsShowMore(true);
        }
    }

    return (
        <div className="aboutLot detailsWrapper">
            <div className="dataTable">
                {lot.Filters ? (
                    <>
                        {lot.Filters.map((item) => {
                            return (
                                <div className="dataItem">
                                    <span className="defaultDataName">{item.FilterName}:</span>
                                    <p className="defaultDataValue">{item.Value}</p>
                                </div>
                            )
                        })}
                    </>
                ) : (
                    <p className="errorText">Данные отсутствуют</p>
                )}
            </div>

            <div className="description">
                <span className="defaultDataName">Дополнительная <br /> информация:</span>
                <div className="descriptionText">
                    <p>
                        {lot.Information}
                    </p>
                    {isShowMoreButton &&
                        <span onClick={showMore}>
                            {isShowMore ? 'Скрыть' : 'Показать больше'}
                        </span>
                    }
                </div>
            </div>

            <div className="extendInfo">
                <label>
                    <span>Нормативный правовой акт, на основании которого проходят торги</span>
                    <input />
                </label>
                <label>
                    <span>Основание реализации имущества</span>
                    <textarea
                        onInput={(e) => {
                            const target = e.target as HTMLTextAreaElement;
                            target.style.height = 'auto';
                            target.style.height = target.scrollHeight + 'px';
                        }}
                    />
                </label>
                <label>
                    <span>Собственник имущества</span>
                    <input />
                </label>
                <label>
                    <span>Порядок ознакомления с имуществом</span>
                    <input />
                </label>
                <label>
                    <span>Обременения реализуемого имущества</span>
                    <input />
                </label>
                <label>
                    <span>Условия договора, заключаемого по результатам торгов</span>
                    <input />
                </label>
                <label>
                    <span>Срок заключения договора</span>
                    <input />
                </label>
                <label>
                    <span>Порядок и сроки уплаты покупной цены по итогам проведения торгов</span>
                    <input />
                </label>
            </div>
        </div>
    )
}


export default AboutLotTab;